import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import ResetPasswordForm from 'forms/ResetPassword'
import Paper from 'components/Paper'
import Center from 'layout/Center'

import styles from './index.css'

import handleFormErrors from 'utils/handleFormErrors'

import AuthAPI from 'api/AuthAPI'
import { setToken } from 'utils/auth'


@withRouter
export default class ResetPassword extends React.Component {
  
  static propTypes = {
  }

  state = {
    tokenError: null,
    success: false
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  async submit(values) {
    const v = {
      password: values.newPassword,
      password_confirmation: values.confirmPassword,
      token: this.props.match.params.token
    }

    try {
      const res = handleFormErrors(await AuthAPI.resetPassword(v))
      this.setState({ tokenError: null, success: true })
    } catch(e) {
      if (e.errors && e.errors.token) {
        this.setState({ tokenError: e.errors.token })
      }
      throw e;
    }
  }

  render() {
    return (
      <Center>
        {
          !this.state.success &&
            <Paper>
              <ResetPasswordForm 
                form={'ResetPasswordForm'}
                onSubmit={this.submit}
                initialValues={{newPassword: 'Matra.360', confirmPassword: 'Matra.360'}}/>
              {
                this.state.tokenError &&
                <div className={styles.Error}>
                  {this.state.tokenError}
                </div>
              }
            </Paper>
        }
        {
          this.state.success &&
            <Paper>
              <div className={styles.SuccessContainer}>
                 <h1>Success</h1>
                <p>Your password has been successfully changed.</p>
                <NavLink 
                  style={{  
                    fontFamily: 'Roboto',
                    fontSize: '1.6rem',
                    lineHeight: '1.5',
                    color: '#f24f12'
                  }}
                  to='/login'>
                  Login
                </NavLink>
              </div>
            </Paper>
        }
      </Center>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/index.jsx